import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useGetNISParticipantDetailsById } from "../../api/services/nisParticipants/nisParticipantsApis";
import { PAGE_IDS } from "../../helpers/constants";
import { useSiteCore } from "../../hooks/useSiteCore";
import { useToast } from "../../hooks/useToast";
import { toggleLoader } from "../../redux/slices/appState/appStateSlice";
import CreateNISParticipant from "../createNISParticipant/CreateNISParticipant";

const EditNISParticipant: FC = () => {
  const { id: nisParticipantId } = useParams<{ id: string }>();
  const { commonLabels } = useSiteCore();
  const { displayToast } = useToast();
  const dispatch = useDispatch();

  const {
    data: nisParticipantData,
    isFetching: isNISParticipantDataLoading,
    error: nisParticipantDataError,
  } = useGetNISParticipantDetailsById(nisParticipantId);

  useEffect(() => {
    if (nisParticipantDataError) {
      displayToast(commonLabels.someThingWentWrongPleaseTryAgainLater);
    }
  }, [nisParticipantDataError]);

  useEffect(() => {
    dispatch(
      toggleLoader({
        isFetchingNISData: {
          isVisible: isNISParticipantDataLoading,
          message: commonLabels.loadingPleaseWait,
        },
      }),
    );
    return () => {
      dispatch(toggleLoader({ isFetchingNISData: { isVisible: false } }));
    };
  }, [isNISParticipantDataLoading]);

  return (
    <CreateNISParticipant
      isEditNISParticipant={true}
      editNISParticipantData={nisParticipantData}
      nisParticipantId={nisParticipantId}
      pageId={PAGE_IDS.EDIT_NIS_PARTICIPANT}
    />
  );
};

export default EditNISParticipant;
